/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Status_RunningInputs */

const en_course_status_running = /** @type {(inputs: Course_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const ja_course_status_running = /** @type {(inputs: Course_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

const fr_course_status_running = /** @type {(inputs: Course_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_course_status_running = /** @type {(inputs: Course_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Course_Status_RunningInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_running = /** @type {((inputs?: Course_Status_RunningInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_RunningInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_running(inputs)
	if (locale === "ja") return ja_course_status_running(inputs)
	if (locale === "fr") return fr_course_status_running(inputs)
	return de_course_status_running(inputs)
});